<span class="text-center linkout" *ngFor="let itm of data">
    <a class="chip" (click)="sendFeed(itm.textPlain)">{{itm.textPlain}}</a>
</span>